import React from 'react'

const Linkedin = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="45"
            height="41"
            viewBox="0 0 44 41"
            {...props}
        >
            <path
                stroke="none"
                fillRule="nonzero"
                fill="rgb(33.333333%,31.372549%,28.235294%)"
                fillOpacity="1"
                d="M 15.527344 34.746094 C 8.382812 32.539062 4.722656 25.738281 6.316406 17.8125 C 7.660156 11.136719 12.976562 5.757812 19.1875 4.785156 C 25.972656 3.726562 32.675781 6.882812 35.945312 12.671875 C 41.332031 22.214844 35.644531 33.617188 24.722656 35.261719 C 21.648438 35.722656 18.644531 35.574219 15.527344 34.746094 Z M 15.527344 34.746094 "
            />
            <path
                stroke="none"
                fillRule="nonzero"
                fill="rgb(98.431373%,98.431373%,98.431373%)"
                fillOpacity="1"
                d="M 28.453125 18.132812 C 29.1875 18.726562 29.644531 19.390625 29.761719 20.183594 C 30.160156 22.863281 30.382812 25.566406 30.152344 28.269531 C 30.023438 29.824219 28.746094 29.105469 27.921875 29.183594 C 27.132812 29.261719 26.53125 29.105469 26.589844 28.011719 C 26.671875 26.4375 26.664062 24.847656 26.589844 23.273438 C 26.535156 22.03125 26.480469 20.671875 24.726562 20.625 C 23.316406 20.585938 22.667969 21.371094 22.625 23.238281 C 22.589844 24.816406 22.542969 26.402344 22.636719 27.976562 C 22.714844 29.226562 21.949219 29.195312 21.160156 29.191406 C 20.347656 29.183594 19.226562 29.648438 19.121094 28.21875 C 18.886719 25.007812 18.945312 21.789062 19.089844 18.574219 C 19.128906 17.664062 19.738281 17.550781 20.472656 17.511719 C 22.199219 17.417969 22.410156 17.5 22.867188 18.75 C 24.539062 17.191406 26.367188 16.921875 28.453125 18.132812 Z M 28.453125 18.132812 "
            />
            <path
                stroke="none"
                fillRule="nonzero"
                fill="rgb(97.254902%,97.254902%,97.254902%)"
                fillOpacity="1"
                d="M 17.3125 26.050781 C 17.300781 26.605469 17.261719 27.003906 17.289062 27.398438 C 17.386719 28.769531 16.90625 29.453125 15.425781 29.492188 C 13.949219 29.527344 13.535156 28.894531 13.464844 27.507812 C 13.328125 24.742188 13.347656 21.980469 13.339844 19.21875 C 13.339844 17.847656 13.953125 17.300781 15.273438 17.316406 C 16.503906 17.332031 17.257812 17.652344 17.234375 19.117188 C 17.191406 21.375 17.28125 23.628906 17.3125 26.050781 Z M 17.3125 26.050781 "
            />
            <path
                stroke="none"
                fillRule="nonzero"
                fill="rgb(97.254902%,97.254902%,97.254902%)"
                fillOpacity="1"
                d="M 17.265625 13.890625 C 17.105469 14.953125 16.808594 15.796875 15.75 15.980469 C 14.628906 16.171875 13.726562 15.761719 13.410156 14.625 C 13.097656 13.5 13.585938 12.578125 14.691406 12.242188 C 15.988281 11.847656 16.992188 12.222656 17.265625 13.890625 Z M 17.265625 13.890625 "
            />
        </svg>
    )
}

export default Linkedin
